import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }
const _hoisted_2 = { class: "card border-0 shadow-none rounded-1 mb-25" }
const _hoisted_3 = { class: "card-body p-xl-40" }
const _hoisted_4 = { class: "row g-3 align-items-center" }
const _hoisted_5 = { class: "col-lg-8" }
const _hoisted_6 = { class: "d-flex flex-wrap align-items-center gap-2" }
const _hoisted_7 = {
  type: "button",
  class: "btn style-two px-4 h-55",
  "data-bs-toggle": "modal",
  "data-bs-target": "#registerHistoryFilterModal"
}
const _hoisted_8 = { class: "search-box position-relative" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = {
  class: "modal fade",
  id: "registerHistoryFilterModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_11 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_12 = { class: "modal-content border-0 shadow" }
const _hoisted_13 = { class: "modal-header border-bottom-dashed" }
const _hoisted_14 = { class: "modal-title fw-bold" }
const _hoisted_15 = ["aria-label"]
const _hoisted_16 = { class: "modal-body" }
const _hoisted_17 = { class: "row g-3" }
const _hoisted_18 = { class: "col-12" }
const _hoisted_19 = { class: "form-label fs-14 text-title" }
const _hoisted_20 = { value: null }
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "col-12" }
const _hoisted_23 = { class: "form-label fs-14 text-title" }
const _hoisted_24 = { value: null }
const _hoisted_25 = { value: 1 }
const _hoisted_26 = { value: 0 }
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = { class: "form-label fs-14 text-title" }
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = { class: "form-label fs-14 text-title" }
const _hoisted_31 = { class: "modal-footer border-top-dashed justify-content-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainSidebar = _resolveComponent("MainSidebar")!
  const _component_BreadcrumbMenu = _resolveComponent("BreadcrumbMenu")!
  const _component_RegisterHistory = _resolveComponent("RegisterHistory")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainHeader),
    _createVNode(_component_MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BreadcrumbMenu, { pageTitle: _ctx.pageTitle }, null, 8, ["pageTitle"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", _hoisted_7, [
                  _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.i18nScope}.filter`)) + " ", 1),
                  _cache[7] || (_cache[7] = _createElementVNode("i", { class: "ri-filter-line ms-1" }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                    type: "text",
                    placeholder: _ctx.$t(`${_ctx.i18nScope}.search_placeholder`),
                    class: "form-control bg-white h-55 shadow-none pe-5"
                  }, null, 8, _hoisted_9), [
                    [_vModelText, _ctx.searchQuery]
                  ]),
                  _cache[8] || (_cache[8] = _createElementVNode("span", { class: "search-icon" }, [
                    _createElementVNode("i", { class: "ri-search-line" })
                  ], -1))
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_RegisterHistory, {
        items: _ctx.items,
        loading: _ctx.loading,
        pagination: _ctx.pagination,
        summary: _ctx.summary,
        "i18n-scope": _ctx.i18nScope,
        onTableChange: _ctx.handleTableChange
      }, null, 8, ["items", "loading", "pagination", "summary", "i18n-scope", "onTableChange"]),
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(_component_MainFooter)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("h5", _hoisted_14, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.advanced_filter`)), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close shadow-none",
              "data-bs-dismiss": "modal",
              "aria-label": _ctx.$t('common.close')
            }, null, 8, _hoisted_15)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.user`)), 1),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select bg-light border-0 fs-14 shadow-none",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.user_id) = $event))
                }, [
                  _createElementVNode("option", _hoisted_20, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.all_users`)), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: user.id,
                      value: user.id
                    }, _toDisplayString(_ctx.formatUserLabel(user)), 9, _hoisted_21))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.filters.user_id]
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.status`)), 1),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select bg-light border-0 fs-14 shadow-none",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.status) = $event))
                }, [
                  _createElementVNode("option", _hoisted_24, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.all_status`)), 1),
                  _createElementVNode("option", _hoisted_25, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.status_open`)), 1),
                  _createElementVNode("option", _hoisted_26, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.status_closed`)), 1)
                ], 512), [
                  [_vModelSelect, _ctx.filters.status]
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.from_date`)), 1),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.from_date) = $event)),
                  type: "date",
                  class: "form-control bg-light border-0 fs-14 shadow-none"
                }, null, 512), [
                  [_vModelText, _ctx.filters.from_date]
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.to_date`)), 1),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.to_date) = $event)),
                  type: "date",
                  class: "form-control bg-light border-0 fs-14 shadow-none"
                }, null, 512), [
                  [_vModelText, _ctx.filters.to_date]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-light",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
            }, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.reset`)), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
            }, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.apply_filter`)), 1)
          ])
        ])
      ])
    ])
  ], 64))
}